import { render, staticRenderFns } from "./FormResearch1.vue?vue&type=template&id=fc62a5c6"
import script from "./FormResearch1.vue?vue&type=script&lang=js"
export * from "./FormResearch1.vue?vue&type=script&lang=js"
import style0 from "./FormResearch1.vue?vue&type=style&index=0&id=fc62a5c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports